function FilesystemConfig($compileProvider){
    "ngInject";

    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|filesystem):/);
}

export default FilesystemConfig;
